/**
 * Just a wrapper around the gapi lib from Google to make it injectable.
 * In the case where it isn't available (unit tests as an example) return `{}`.
 */
export default /* @ngInject */ $window => $window.gapi || {};
